import { ReactNode } from 'react';
import {
  Box,
  Modal,
  ModalContent,
  ModalOverlay,
  ModalFooter as ModalFooterCK,
} from '@chakra-ui/react';
import { Text } from '@mercator-gcp/grout';

const contentStyle = {
  maxWidth: '500px',
  width: 'fit-content',
};

const titleStyle = {
  paddingBottom: 'padding_16',
};

const modalBodyStyle = {
  padding: 'padding_16',
  paddingBottom: '0px',
};

const modalFooterStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  padding: 'padding_16',
};

type ModalContentProps = {
  title?: string | ReactNode;
  children: ReactNode;
};

const ModalBody = ({ title, children }: ModalContentProps) => {
  return (
    <Box sx={modalBodyStyle}>
      {title && <Text.Lead sx={titleStyle}>{title}</Text.Lead>}
      {children}
    </Box>
  );
};

type ModalFooterProps = {
  children: ReactNode;
};

const ModalFooter = ({ children }: ModalFooterProps) => {
  return <ModalFooterCK sx={modalFooterStyle}>{children}</ModalFooterCK>;
};

type BasicModalProps = {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
};

const BasicModal = ({ isOpen, onClose, children }: BasicModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent sx={contentStyle}>{children}</ModalContent>
    </Modal>
  );
};

BasicModal.Body = ModalBody;

BasicModal.Footer = ModalFooter;

export default BasicModal;
